import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  isShow: false,
  msg: '',
  align: ''
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action) => {
      state.isShow = true;
      state.msg = action.payload.msg;
      state.align = action.payload.align;
    },
    hideToast: (state) => {
      state.isShow = false;
    }
  }
});

export const { showToast, hideToast } = toastSlice.actions;
export const useToastSliceSelector = createSelectorFn(toastSlice);
export default toastSlice;
